import React from "react";
import ReactDom from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";

const OverlayRedirect = ({ setOpenOverlay, loc }) => {
  const navigate = useNavigate();
  return ReactDom.createPortal(
    <div className="flex flex-col fixed h-[100vh] w-[100vw] bg-opacity-30 bg-gray-400 top-0 left-0 z-[999999] backdrop-blur-sm justify-center items-center">
      <div className="flex flex-col bg-white border border-gray-200 rounded-lg p-5 max-w-[90%] md:max-w-[50%] gap-5">
        <div className="flex flex-row justify-between">
          <div className="text-lg font-semibold">
            You are leaving the page 😢
          </div>
          <div
            className="px-3 hover:bg-red-200 rounded-full cursor-pointer font-bold"
            onClick={(e) => {
              e.preventDefault();
              setOpenOverlay(false);
            }}
          >
            x
          </div>
        </div>

        <div>
          Please don't leave this page — information{" "}
          <b>you’ve entered may not be saved.</b>
        </div>
        <div className="flex flex-row w-full justify-end items-center gap-5">
          <div
            className="flex flex-col py-2 px-4 bg-white text-secondary hover:text-white hover:bg-red-400 cursor-pointer rounded-lg"
            onClick={(_) => navigate(loc)}
          >
            Leave the page
          </div>
          <div
            className="flex flex-col py-2 px-4 bg-primary text-white hover:bg-secondary cursor-pointer rounded-lg"
            onClick={(_) => setOpenOverlay(false)}
          >
            Stay in page
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default OverlayRedirect;
